export default __webpack_public_path__ + "static/media/rtg-4.c063f45f.svg";